export default __webpack_public_path__ + "static/media/RosanaRodrigues_06.a23932e5.jpg";